<template>
  <i :style="styles"
     :class="[icon]"
     class="service-left-icon">
  </i>
</template>

<script>
  export default {
    name: 'service-left-icon',
    props: {
      serviceOrder: {type: Object, required: true},
      size: {type: String, default: '48px'},
    },
    computed: {
      icon() {
        return {
          medicine: 'ns-icon-ico012',
          watsons: 'ns-icon-ico012',
          diagnostics: 'ns-icon-ico013',
        }[this.serviceOrder.ordertype];
      },
      styles() {
        return {
          fontSize: this.size,
        };
      },
    },
  }
</script>

<style lang="scss">

</style>
